var React = require('react');

function Am (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"red","d":"M0 0h640v160H0z","key":0}),React.createElement("path",{"fill":"#00f","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"fill":"orange","d":"M0 320h640v160H0z","key":2})]);
}

Am.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Am;

Am.default = Am;
